export const LabelQcFieldName = 'labelQcFieldComponent';
